import {
  Radio as HeroUIRadio,
  RadioProps as HeroUIRadioProps,
  groupDataFocusVisibleClasses,
  hiddenInputClasses,
} from "@heroui/react";
import clsx from "clsx";

type Color = "primary";
type Size = "sm" | "lg" | "md";

export type RadioProps = Omit<
  HeroUIRadioProps,
  "color" | "size" | "onClick"
> & {
  color?: Color;
  onClick?: never;
  size?: Size;
};

export const Radio = ({ color, isInvalid, size, ...props }: RadioProps) => {
  return (
    <HeroUIRadio
      {...props}
      classNames={{
        control: clsx(
          "scale-0 rounded-full opacity-0 group-data-[selected=true]:scale-100 group-data-[selected=true]:opacity-100",
          {
            "bg-primary text-primary-foreground": color === "primary",
            "border-danger bg-danger": isInvalid,
            "h-1.5 w-1.5": size === "sm",
            "h-2.5 w-2.5": size === "lg",
            "h-2 w-2": size === "md",
          },
        ),
        description: clsx("text-gray-600", {
          "text-gray-600!": color === "primary",
          "text-medium": size === "lg",
          "text-tiny": size === "sm" || size === "md",
        }),
        hiddenInput: hiddenInputClasses,
        label: clsx("text-gray-900", {
          "text-body-md!": size === "md",
          "text-gray-900!": color === "primary",
          "text-large": size === "lg",
          "text-small": size === "sm" || size === "md",
        }),
        labelWrapper: clsx({
          "ml-1": size === "sm",
          "ml-2": size === "lg" || size === "md",
        }),
        wrapper: clsx(
          "rounded-full border-medium border-solid border-default group-data-[hover-unselected=true]:bg-default-100",
          {
            "border-danger group-data-[selected=true]:border-danger": isInvalid,
            "group-data-[selected=true]:border-primary": color === "primary",
            "h-4 w-4": size === "sm",
            "h-5 w-5": size === "md",
            "h-6 w-6": size === "lg",
            ...groupDataFocusVisibleClasses,
          },
        ),
      }}
      data-testid={`${props.name}-${props.value}`}
    />
  );
};
